// import React, { useState } from "react";

// const TermsModal = ({ setIsTermsActive }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   const handleAgree = () => {
//     setIsTermsActive(true); // Enable checkbox in the parent component
//     setIsOpen(false); // Close the modal
//   };

//   return (
//     <div>
//       {/* Button to Open Modal */}
//       <button
//         onClick={() => setIsOpen(true)}
//         className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//       >
//         Terms & Conditions
//       </button>

//       {/* Modal Overlay & Content */}
//       {isOpen && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-96">
//             {/* Modal Header */}
//             <div className="flex justify-between items-center">
//               <h2 className="text-xl font-semibold">Terms & Conditions</h2>
//               <button
//                 onClick={() => setIsOpen(false)}
//                 className="text-gray-600 hover:text-gray-900"
//               >
//                 ✖
//               </button>
//             </div>

//             {/* Modal Body */}
//             <div className="mt-4 text-gray-700 text-sm">
//               <p>
//                 By using this application, you agree to our terms and
//                 conditions. Ensure you read them carefully.
//               </p>
//               <ul className="list-disc list-inside mt-2">
//                 <li>Respect privacy and data security.</li>
//                 <li>Do not misuse the services provided.</li>
//                 <li>Any violations may lead to termination of access.</li>
//               </ul>
//             </div>

//             {/* Modal Footer */}
//             <div className="mt-4 flex justify-end">
//               <button
//                 onClick={handleAgree} // Call the agree handler
//                 className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
//               >
//                 Ok... I Have Read Above Terms & Conditions
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TermsModal;


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth"; // Adjust this path as needed

// Updated TermsModal component that doesn't render its own button
const TermsModal = ({ isOpen, setIsOpen, setIsTermsActive,  onModalOpen }) => {

    useEffect(() => {
        if (isOpen && typeof onModalOpen === 'function') {
          onModalOpen();
        }
      }, [isOpen, onModalOpen]);
    const handleAgree = () => {
        setIsTermsActive(true); // Enable checkbox in the parent component
        setIsOpen(false); // Close the modal
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-99 h-100">
                {/* Modal Header */}
                <div className="flex justify-between items-center">
                    <h2 className="text-xl font-semibold">Terms & Conditions</h2>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="text-gray-600 hover:text-gray-900"
                    >
                        ✖
                    </button>
                </div>

                {/* Modal Body */}
                <div className="mt-4 text-gray-700 text-lg">
                    <p>
                        By using this application, you agree to our terms and
                        conditions. Ensure you read them carefully.
                    </p>
                    <ul className="list-disc list-inside mt-2">
                        <li>Respect privacy and data security.</li>
                        <li>Do not misuse the services provided.</li>
                        <li>Any violations may lead to termination of access.</li>
                    </ul>
                </div>

                {/* Modal Footer */}
                <div className="mt-4 flex justify-center">
                    <button
                        onClick={handleAgree} // Call the agree handler
                        className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                    >
                        Ok... I Have Read Above Terms & Conditions
                    </button>
                </div>
            </div>
        </div>
    );
};
export default TermsModal;
